import { backendApi } from "@/services/backend/api";
import { Filter } from "@/shared/lib/filter/filter";
import { ODataList } from "@/services/backend/business-central/api/odata-list";
import { Company } from "@/services/backend/business-central/types/company";

const companyApi = backendApi.injectEndpoints({
  endpoints: (build) => ({
    businessCentralCompanyShow: build.query<Company, ShowCompanyRequest>({
      query: (request) => ({
        url: `/business-central/companies`,
        method: "GET",
        params: request,
      }),
    }),
    businessCentralCompanyList: build.query<
      ODataList<Company>,
      ListCompanyRequest
    >({
      query: (request) => ({
        url: `/business-central/companies/list`,
        method: "GET",
        params: request,
      }),
    }),
  }),
});

export const {
  useBusinessCentralCompanyShowQuery,
  useBusinessCentralCompanyListQuery,
} = companyApi;

export type ShowCompanyRequest = {
  id: string;
};

export type ListCompanyRequest = {
  name?: Filter<string>;
};
